/* eslint-disable react/prop-types, react/jsx-props-no-spreading */
import React from 'react';

import { pluralize } from '@utils';
import { InfoItem } from '@molecules';
import { useMedia } from '@api/hooks';
import { getImage } from '@utils/media';

const Item = ({ module, errors, ...props }) => {
  const { media } = useMedia(getImage(module.content?.banners?.[0]));

  return (
    <InfoItem.WithError
      {...props}
      error={errors}
      size="large"
      image={media.src}
      description={pluralize(module.content.banners?.length, 'banner')}
    >
      Promotional Banner
    </InfoItem.WithError>
  );
};

export default Item;
